'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Grid": "Polaris-Grid"
};

exports.default = styles;
